import React, { useState } from "react";
import { FaShare } from "react-icons/fa";
import { IoHeartCircle } from "react-icons/io5";
import { IoChatbox } from "react-icons/io5";
import newsPortal1 from "../assets/images/news-port1.svg";
import newsPortal2 from "../assets/images/news-port2.svg";
import newsPortal3 from "../assets/images/news-port3.svg";
import news1 from "../assets/images/news1.svg";
import news2 from "../assets/images/news2.svg";
import news3 from "../assets/images/news3.jpg";
import Button from 'react-bootstrap/Button';
import { IoPaperPlane } from "react-icons/io5";
import { useAuth } from "../../src/context/AuthContext";


const articles = [
  {
    id: 1,
    type: "article", // Regular post
    username: "USD Today",
    timeAgo: "10m ago",
    profilePic: newsPortal1, // Replace with actual profile picture URL
    image: news1, // Replace with actual post image
    title: "President Grump proposes US takeover of Gaza, sparks outrage",
    caption: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "851",
    comments: "425",
    shares: "68",
    auther: "Anthony Robledo",
    repoter: "",
    trending: "Trending"
  },
  {
    id: 2,
    type: "article", // Regular post
    username: "Time of Inonesia",
    timeAgo: "20m ago",
    profilePic: newsPortal2, // Replace with actual profile picture URL
    image: news2, // Replace with actual post image
    title: "Someone has stolen 100,000 eggs from a Sylvania company. Police say they're worth $40K",
    caption: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "721",
    comments: "425",
    shares: "68",
    auther: "Robert Brown",
    repoter: "(Repoter)"
  },
  {
    id: 3,
    type: "article", // Regular post
    username: "Reuters",
    timeAgo: "10m ago",
    profilePic: newsPortal3, // Replace with actual profile picture URL
    image: news3, // Replace with actual post image
    title: "President Grump proposes US takeover of Gaza, sparks outrage",
    caption: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "851",
    comments: "425",
    shares: "68",
    auther: "Anthony Robledo",
    repoter: "",
    trending: "Trending"
  },

];

const Article = ({ article }) => {


  const { isAuthenticated } = useAuth();
  const [loved, setLoved] = useState(false);
  const [commentsOpen, setCommentsOpen] = useState(false); // Track visibility
  const [searchText, setSearchText] = useState("");



  return (
    <div className="article-wraper">
      <div className="article">
        {/* Header Section */}
        <div className="article-header">
          <div className="profile-image"><img src={article.profilePic} alt="Profile" className="profile-pic" /></div>
          <div className="profile-text">
            <div className="left-part">
                <h4>{article.username}
                  <p className="time-ago">
                    {article.timeAgo}
                  </p>
                </h4>
                <p className="article-auther">
                  {article.auther}
                  <span>{article.repoter}</span>
                </p>
            </div>
            {isAuthenticated && (
                <Button variant="outline-primary" className="br-10 follow-btn">
                  JOIN
                </Button>
            )}
          </div>
        </div>
        {/* Caption Section */}
        <div className="caption">
          <h4>{article.title}</h4>
          <p>{article.caption}</p>
        </div>
        {/* article Image */}
        <div className="article-image">
          <img src={article.image} alt="article" />
        </div>
        {/* Actions Section */}
        <div className="article-actions">
          {/* Love Button */}
          <div className="items">
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="link"
              className="p-0 no-underline action-button"
              onClick={() => setLoved(!loved)}
            >
              <IoHeartCircle className="icon" />
              <span>{loved ? parseInt(article.likes) + 1 : article.likes} <span className="item-text">Loves</span></span>
            </Button>
          </div>

          {/* Comment Button */}
          <div className="items">
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="link"
              className="p-0 no-underline action-button"
              onClick={() => setCommentsOpen(!commentsOpen)}
            >
              <IoChatbox className="icon" />
              <span>{article.comments} <span className="item-text">Comments</span></span>
            </Button>
          </div>

          {/* Share Button */}
          <div className="items">
            <span><span className="item-text">{article.shares} Times Shared</span></span>
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="outline-secondary"
              className="br-10 share-button"
            >
              <FaShare className="icon" />
              Share
            </Button>
          </div>
        </div>

        {/* Comment Box - Controlled by commentsOpen */}
        <div className={`comment-box ${commentsOpen ? "show" : "hide"}`}>
          <input
            type="text"
            placeholder="Add your comment here"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Button variant="secondary" className={`search-button ${searchText ? "active" : ""}`}>
            <IoPaperPlane />
          </Button>
        </div>
      </div>
    </div>
  );
};

const ArticleList = ({ filterByUser, trending }) => {
  // Filter articles based on `filterByUser` OR `trending`
  const filteredArticles = articles.filter((article) => {
    if (filterByUser && article.username !== filterByUser) {
      return false; // Filter by username
    }
    if (trending && article.trending !== trending) {
      return false; // Filter only trending articles
    }
    return true; // Show if it passes the conditions
  });

  return (
    <div className="article-list">
      {filteredArticles.map((article) => (
        <Article key={article.id} article={article} />
      ))}
    </div>
  );
};

export default ArticleList;
